import React from "react";

type Props = {
  status: boolean;
  children?: React.ReactNode;
};

const DisableContent: React.FC<Props> = ({ children, status = false }) => {
  return <div className={status ? "content-disabled" : ""}>{children}</div>;
};

export default DisableContent;
